import React, { createRef } from "react";
import Tilt from "react-tilted";
import { useOnScreen } from "../../components/useOnScreen";
import { MobileWidth, Title, Wrapper } from "../../GlobalStyle";
import { HeroWrapper } from "./Styled";
import { useMediaQuery } from "react-responsive";

const Image = () => {
  const isMobile = useMediaQuery({ query: `(max-width: ${MobileWidth})` });
  return isMobile ? (
    <img src={require("../../images/hero-img.png")} alt="Seedverse" />
  ) : (
    <Tilt className="Tilt" max={25} speed={2000}>
      <div className="Tilt-inner">
        <img
          className="tilt-image human"
          src={require("../../images/hero-human.png")}
          alt="Seedverse"
        />
      </div>
      <div className="Tilt-inner coin">
        <img
          className="tilt-image coin"
          src={require("../../images/hero-coin.png")}
          alt="Seedverse"
        />
      </div>
    </Tilt>
  );
};

function Hero() {
  const containerRef = createRef();
  const isVisible = useOnScreen(containerRef);

  return (
    <HeroWrapper
      id="home"
      className={isVisible ? "active" : ""}
      ref={containerRef}
    >
      <Wrapper>
        <div className="hero-left">
          <Title>
            Transform your
            <br />
            business with NFTs
          </Title>
          <p>Welcome to the Future</p>
          <div>
            <a href="#about" className="btn">
              Explore
            </a>
          </div>
        </div>
        <div className="hero-right">
          <Image />
        </div>
      </Wrapper>
    </HeroWrapper>
  );
}
export default Hero;
